import { codeEnums } from '@/shared/utils/platform';

/** 当前首页按钮埋点名称统一，目前app和小程序不一致，待后续统一 */
export const ubtName = {
  [codeEnums.alipayMini]: {
    repay: '臻有钱_首页_我要还款',
    apply: '臻有钱_首页_立即提现',
    prechoose: 'finance_tagless_ExpriedCreditApply',
  },
};
